import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  es: {
    translation: esTranslation
  }
};

i18n
  // Detect user language (e.g., from browser settings)
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en', // Default language if translation is missing
    interpolation: {
      escapeValue: false, // React already prevents XSS
    },
    detection: {
        order: ['localStorage', 'navigator'], // Order to check language
    },
    ns: ['translation'], // Specify the namespace (we are using 'translation' here)
    defaultNS: 'translation'
  });

export default i18n;
